import dayjs, { type Dayjs } from "dayjs";
import { useEffect, useReducer } from "react";

export const getSecondsUntil = (until: Dayjs | null, now: Dayjs = dayjs()) =>
  until ? Math.max(0, Math.ceil(until.diff(now) / 1000)) : 0;

export const formatCountdown = (seconds: number) =>
  `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;

export const useCountdown = (until: Dayjs | null) => {
  const [, tick] = useReducer((count: number) => count + 1, 0);
  const secondsLeft = getSecondsUntil(until);
  const isRunning = secondsLeft > 0;

  useEffect(() => {
    if (!isRunning) return;

    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [isRunning, until]);

  return secondsLeft;
};
